import { Component, computed, inject, model, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from 'node_modules/@angular/router';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { BusinessStore } from 'src/model/business/business-store';
import { Company } from 'src/model/company.model';
import { FinanceAccount } from 'src/model/financeAccount.model';
import { CompanyService } from 'src/services/company.service';
import { FinanceAccountService } from 'src/services/finance-account.service';

@Component({
    selector: 'app-maintain-business-license',
    templateUrl: './maintain-business-license.component.html',
    styleUrl: './maintain-business-license.component.scss',
    standalone: false
})
export class MaintainBusinessLicenseComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private companyService = inject(CompanyService);
  private faService = inject(FinanceAccountService);
  private store = inject(BusinessStore);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected enums = inject(Enums);

  readonly TABS = {
    BUSINESS: 0,
    BRANCH: 1,
    LICENSE: 2,
  };
  tab = model<number>(0);

  companyList = signal<Company[]>([]);
	faList = signal<FinanceAccount[]>([]);

  searchText = signal<string>('');
  branchIdFilter = signal<number>(undefined);

  isBoss = computed(() => this.sharedService.isBossAccount());

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe(params => {
      const t = Number(params['tab']);
      if (t && t !== this.tab()) this.tab.set(t);
    });
  }

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    const [c, f] = await Promise.all([
      this.companyService.getAllCompanies(),
      this.faService.getAllFinanceAccounts()
    ]);
    this.companyList.set(c);
    this.faList.set(f);
  }

  addBusiness() {
    this.store.addBusiness();
  }

  addBusinessBranch(businessId?: number) {
    this.store.addBusinessBranch(businessId);
  }

  showBranchOfBusiness(event: string) {
    this.tab.set(this.TABS.BRANCH);
    this.searchText.set(event);
  }

  showLicenseOfBusinessBranch(name: string, branchId: number) {
    this.tab.set(this.TABS.LICENSE);
    this.searchText.set(name);
    this.branchIdFilter.set(branchId);
  }

  onToggleView() {
    this.searchText.set('');
    this.branchIdFilter.set(undefined);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: this.tab() },
      queryParamsHandling: 'merge', // Keep other existing params
    });
  }
}
